import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-10 sm:py-14 relative" data-id="element-302">
      <div className="mx-auto max-w-3xl px-6 lg:px-8 text-center" data-id="element-303">
        <FadeIn data-id="element-304">
          <p className="text-2xl sm:text-3xl font-serif italic text-slate-100 leading-relaxed mb-4" data-id="element-305">
            "Son las 3:15 de la mañana. Estás en la cocina, con los ojos ardidos
            por el cansancio, sirviendo una porción de alimento que no
            corresponde solo para que 'se calle'."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-306">
          <p className="text-lg text-slate-400 leading-relaxed font-sans" data-id="element-307">
            Te sentís culpable por estar enojado con el animal que amás, pero la
            falta de sueño está destruyendo tu productividad, tu humor y tu
            paciencia. No sos un mal dueño; simplemente sos una víctima de la
            biología de tu gato.
          </p>
        </FadeIn>
      </div>
    </section>;
}